import './PopUpButton.css';
import React from "react";

function PopUpButton(props) {
    return (
        <div className="popUpButton">
            <p> are you sure you want to delete this task?</p>
            <p> "{props.taskDescription}" </p>
            <div className="row popUpButtonRow"> 
                <p className="popUpButtonOption" onClick={() => props.setShowPopUpButton(false)}>no, don't delete</p>
                <p className="popUpButtonOption" onClick={() => props.deleteUserData()}>yes, delete</p>
            </div>
        </div>
    )
}

export default PopUpButton;